import { render, staticRenderFns } from "./TransactionSuccess.vue?vue&type=template&id=3b65a958&scoped=true&"
import script from "./TransactionSuccess.vue?vue&type=script&lang=js&"
export * from "./TransactionSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TransactionSuccess.vue?vue&type=style&index=0&id=3b65a958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b65a958",
  null
  
)

export default component.exports